__turbopack_context__.v({
  "body": "styles-module-scss-module__TY7h1G__body",
  "grayscale": "styles-module-scss-module__TY7h1G__grayscale",
  "header": "styles-module-scss-module__TY7h1G__header",
  "image-container": "styles-module-scss-module__TY7h1G__image-container",
  "reason-container": "styles-module-scss-module__TY7h1G__reason-container",
  "text-container": "styles-module-scss-module__TY7h1G__text-container",
});
